var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('widget-stats-count',{attrs:{"url":"Documents","widgetStyle":"simple","dark":true,"color":"#00A9F4","icon":"mdi-database","title":"of storage used","stat":_vm.totalStorage|| '0 kb'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }